import type {ReactElement} from 'react';
import type {TabButtonProps} from './tab-button.types';
import styles from './tab-button.module.scss';

export function TabButton({tab, label, isActive, isDisabled = false, onSelect}: TabButtonProps): ReactElement {
  const handleClick = (): void => {
    onSelect(tab);
  };
  return (
    <button type="button" role="tab" aria-selected={isActive} disabled={isDisabled} className={`${styles.tab} ${isActive ? styles.active : ''}`} onClick={handleClick}>
      {label}
    </button>
  );
}
